<template>
  <div class="big mydialog">
    <div class="page_title flex_between">
      <span>医生坐班表配置</span>
      <el-button
        type="primary"
        style="width: 92px"
        @click="back"
        size="medium"
      >返回</el-button>
    </div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="info">
          <div>
            <span class="item">
              <span class="black">医生姓名</span>
              <span>{{ detail.doctor_name }}</span>
            </span>
            <span class="item">
              <span class="black">性别</span>
              <span v-if="detail.sex == 1">男</span>
              <span v-if="detail.sex == 2">女</span>
            </span>
            <span class="item">
              <span class="black">手机号</span>
              <span>{{ detail.phone }}</span>
            </span>
            <span class="item">
              <span class="black">职称</span>
              <span>{{ detail.title }}</span>
            </span>
          </div>
          <div style="margin: 12px 0">
            <span class="item">
              <span class="black">所在地区</span>
              <span>{{ detail.province_name }}</span>
              <span>{{ detail.city_name }}</span>
              <span>{{ detail.district_name }}</span>
            </span>
            <span class="item">
              <span class="black">医院名称</span>
              <span>{{ detail.hospital }}</span>
            </span>
            <span class="item">
              <span class="black">科室</span>
              <span>{{ detail.department_name }}</span>
            </span>
          </div>
          <div>
            <span class="item">
              <span class="black">擅长方向</span>
              <span>{{ detail.good_at }}</span>
            </span>
          </div>
        </div>

        <div class="flex">
          <div class="left_box">
            <div class="flex_between">
              <span style="font-size:16px;font-weight:700">
                {{left_data.scheduling_time}}
                {{left_data.dialog_week}}</span>
              <el-button
                type="primary"
                size="medium"
                @click="editDoctorRegisterDia"
                v-if="left_data.scheduling_time >= today"
                :disabled="module_id_array[0] ? !module_id_array.includes('1093') : false"
              >修改</el-button>
            </div>
            <div style="font-size:15px;font-weight:700;margin:16px 0">
              {{left_data.hospital}}
            </div>
            <div v-if="left_list.length==0&&area_id">
              当前日期未设置坐诊信息
            </div>
            <div
              v-for="(item,index) in left_list "
              :key="index"
            >
              <div
                class="diatitle"
                v-if="item.scheduling_type==1"
              >上午坐诊设置</div>
              <div
                v-if="item.scheduling_type==2"
                class="diatitle"
                style="margin-top:20px"
              >下午坐诊设置</div>
              <div
                v-if="item.scheduling_type==4"
                class="diatitle"
                style="margin-top:20px"
              >晚上坐诊设置</div>
              <div v-if="item.scheduling_time">
                <div v-if="item.start_time">
                  <span class="dialabel">坐诊时间</span>
                  <span>
                    <span>{{item.start_time}}</span>
                    <span>~</span>
                    <span>{{item.end_time}}</span>
                  </span>
                </div>
                <div
                  style="margin:10px 0"
                  v-if="item.duration"
                >
                  <span class="dialabel">看诊时长</span>
                  <span>{{item.duration}}分钟</span>
                </div>
                <div>
                  <span class="dialabel">坐诊类型</span>
                  <span v-if="item.type==1">仅坐诊</span>
                  <span v-if="item.type==2">坐诊且放号</span>
                  <span v-if="item.type==3">不坐诊</span>
                  <span
                    v-if="item.type==2"
                    style="margin-left:10px"
                  >{{item.count}}/{{item.total_num}}</span>
                </div>
              </div>
              <div
                v-else
                class="dialabel"
              >
                未设置
              </div>
            </div>

          </div>
          <div id="calendar">
            <div class="hospital_box">
              <div
                class="flex scroll_box"
                :style="{width:hospital_list.length*280+260+'px'}"
              >
                <div
                  class="hospital"
                  v-for="(item,index) in hospital_list"
                  :key="index"
                  @click="changeHospital(item.area_id)"
                  :style="{border:item.area_id==area_id?'1px solid #669961':''}"
                >
                  <div class="name">{{item.hospital}}</div>
                  <div class="address">
                    {{item.province_name}}{{item.city_name}}{{item.district_name}}{{item.address}}
                  </div>
                  <div class="btnbox">
                    <el-button
                      type="text"
                      icon="el-icon-edit-outline"
                      style="font-size:16px;margin-right:-5px"
                      :disabled="module_id_array[0] ? !module_id_array.includes('1089') : false"
                      @click="editHospital(item.area_id)"
                    ></el-button>
                    <el-button
                      type="text"
                      icon="el-icon-delete"
                      style="font-size:16px"
                      :disabled="module_id_array[0] ? !module_id_array.includes('1090') : false"
                      @click="delHospital(item)"
                    ></el-button>
                  </div>
                </div>
                <div class="hospital">
                  <div>
                    <el-button
                      type="text"
                      icon="el-icon-plus"
                      style="font-size:32px"
                      @click="addHospital"
                    ></el-button>
                    <div>
                      <el-button
                        type="text"
                        style="font-size:16px"
                        @click="addHospital"
                        :disabled="module_id_array[0] ? !module_id_array.includes('1089') : false"
                      >添加坐诊地点</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <span>
                <span class="demonstration">选择月份</span>
                <el-date-picker
                  v-model="month"
                  type="month"
                  value-format="yyyy-MM"
                  format="yyyy-MM"
                  style="width:200px;margin-left:10px"
                  @change="changeMonth"
                >
                </el-date-picker>
              </span>
            </div>
            <!-- 标题 -->
            <div class="title">
              {{month}}
            </div>
            <!-- 星期行 -->
            <ul class="weekdays">
              <li
                v-for="(val, key) in weeks"
                :key="key"
                class="weekname"
              >
                <span> {{ val }}</span>
              </li>
            </ul>
            <!-- 日期 -->
            <ul class="days">
              <li
                v-for="(val, key) in days"
                :key="key"
                @click="changeBg(val.scheduling_time)"
                :style="{background:val.scheduling_time==scheduling_time?'#669961':val.scheduling_time < today ? '#EDEDED' : '',
                color:val.scheduling_time==scheduling_time?'#FFFFFF':''}"
              >
                <div>
                  <el-button
                    :style="{color:val.scheduling_time==scheduling_time?'#fff':'#669961'}"
                    type="text"
                    v-if="val.scheduling_time >= today"
                    style="font-size: 20px;margin-top:-14px;"
                    @click="saveDoctorRegisterDia(val.scheduling_time,val)"
                    :disabled="module_id_array[0] ? !module_id_array.includes('1093') : false"
                  >
                    <span :class="chooseClass(val.day)"> {{ val.day.getDate() }}</span>
                  </el-button>
                  <span
                    v-else
                    style="color: #999; font-size: 20px"
                  >{{val.day.getDate()}}</span>
                </div>
                <div v-if="val.scheduling_str">
                  <div>{{val.scheduling_str}}</div>
                  <div v-if="val.count||val.total_num">{{val.count}}/{{val.total_num}}</div>
                </div>
                <div
                  v-if="(val.other_morning||val.other_afternoon||val.other_night)&&!val.scheduling_str"
                  class="other_place"
                  :style="{color:val.scheduling_time==scheduling_time?'#fff':'#ea5c5c'}"
                >
                  <span>其他地点</span>
                  <span v-if="val.other_morning&&val.other_afternoon&&val.other_night">
                    全天
                  </span>
                  <span v-else>
                    <span v-if="val.other_morning">上午</span>
                    <span v-if="val.other_afternoon">下午</span>
                    <span v-if="val.other_night">晚上</span>
                  </span>
                  <span>已设置</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

      </div>
    </div>
    <!-- 设置医院问诊弹窗 -->
    <el-dialog
      title="坐诊地点编辑"
      :visible.sync="register"
      width="800px"
      :close-on-click-modal="false"
    >
      <div class="registerdialogbox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="120px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="坐诊医院"
            prop="hospital"
          >
            <!-- :disabled="is_out==0" -->
            <el-select
              v-model="ruleForm.hospital"
              placeholder="请输入"
              class="name-input"
              clearable
              filterable
              remote
              :remote-method="getHospital"
              style="width:400px"
            >
              <el-option
                v-for="item in search_list"
                :key="item.id"
                :label="item.hospital"
                :value="item.hospital"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="坐诊地区"
            prop="regions"
          >
            <el-cascader
              style="width:400px"
              v-model="ruleForm.regions"
              :options="regions"
              :props="{ expandTrigger: 'hover' }"
            ></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址">
            <el-input
              style="width:400px"
              v-model="ruleForm.address"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="上午坐诊时间">
            <div class="flex">
              <el-form-item prop="morning_start_time">
                <el-time-select
                  style="width:150px"
                  placeholder="起始时间"
                  v-model="ruleForm.morning_start_time"
                  :picker-options="{
                    start: '06:00',
                    step: '00:05',
                    end: '13:55',
                 maxTime:ruleForm.morning_end_time
                            }"
                >
                </el-time-select>
              </el-form-item>
              <span style="margin:0 5px">~</span>
              <el-form-item prop="morning_end_time">
                <el-time-select
                  style="width:150px"
                  placeholder="结束时间"
                  v-model="ruleForm.morning_end_time"
                  :picker-options="{
                    start: '06:00',
                    step: '00:05',
                    end: '13:55',
                    minTime: ruleForm.morning_start_time
                             }"
                >
                </el-time-select>
              </el-form-item>
              <el-form-item prop="morning_duration">
                <span style="margin:0 5px 0 30px">看诊时长</span>
                <el-select
                  v-model="ruleForm.morning_duration"
                  style="width:90px;margin-right:3px"
                  clearable=""
                >
                  <el-option
                    v-for="item in 60"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <span>分钟</span>
              </el-form-item>
            </div>

          </el-form-item>
          <el-form-item label="下午坐诊时间">
            <div class="flex">
              <el-form-item prop="afternoon_start_time">
                <el-time-select
                  style="width:150px"
                  placeholder="起始时间"
                  v-model="ruleForm.afternoon_start_time"
                  :picker-options="{
                    start: '12:00',
                    step: '00:05',
                    end: '19:55',
                 maxTime:ruleForm.afternoon_end_time,
                  minTime: ruleForm.morning_end_time

                            }"
                >
                </el-time-select>
              </el-form-item>
              <span style="margin:0 5px">~</span>
              <el-form-item prop="afternoon_end_time">
                <el-time-select
                  style="width:150px"
                  placeholder="结束时间"
                  v-model="ruleForm.afternoon_end_time"
                  :picker-options="{
                    start: '12:00',
                    step: '00:05',
                    end: '19:55',
                    minTime: ruleForm.afternoon_start_time
                             }"
                >
                </el-time-select>
              </el-form-item>
              <el-form-item prop="afternoon_duration">
                <span style="margin:0 5px 0 30px">看诊时长</span>
                <el-select
                  v-model="ruleForm.afternoon_duration"
                  style="width:90px;margin-right:3px"
                  clearable=""
                >
                  <el-option
                    v-for="item in 60"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <span>分钟</span>
              </el-form-item>
            </div>

          </el-form-item>
          <el-form-item label="晚上坐诊时间">
            <div class="flex">
              <el-form-item prop="night_start_time">
                <el-time-select
                  style="width:150px"
                  placeholder="起始时间"
                  v-model="ruleForm.night_start_time"
                  :picker-options="{
                    start: '18:00',
                    step: '00:05',
                    end: '23:55',
                 maxTime:ruleForm.night_end_time,
                  minTime: ruleForm.afternoon_end_time

                            }"
                >
                </el-time-select>
              </el-form-item>
              <span style="margin:0 5px">~</span>
              <el-form-item prop="night_end_time">
                <el-time-select
                  style="width:150px"
                  placeholder="结束时间"
                  v-model="ruleForm.night_end_time"
                  :picker-options="{
                    start: '18:00',
                    step: '00:05',
                    end: '23:55',
                    minTime: ruleForm.night_start_time
                             }"
                >
                </el-time-select>
              </el-form-item>
              <el-form-item prop="night_duration">
                <span style="margin:0 5px 0 30px">看诊时长</span>
                <el-select
                  v-model="ruleForm.night_duration"
                  style="width:90px;margin-right:3px"
                  clearable=""
                >
                  <el-option
                    v-for="item in 60"
                    :key="item"
                    :label="item"
                    :value="item"
                  />
                </el-select>
                <span>分钟</span>
              </el-form-item>
            </div>
          </el-form-item>
          <el-form-item
            label="是否可选时间"
            prop="change_time"
          >
            <el-radio
              v-model="ruleForm.change_time"
              :label="0"
            >否</el-radio>
            <el-radio
              v-model="ruleForm.change_time"
              :label="1"
            >是</el-radio>
          </el-form-item>
          <el-form-item
            label="开始放号时间"
            required=""
          >
            <div class="flex">
              <span>问诊日期前</span>
              <el-form-item prop="start_release_num_day">
                <el-select
                  v-model="ruleForm.start_release_num_day"
                  style="width:110px;margin:0 5px"
                  placeholder=""
                >
                  <el-option
                    v-for="item in 31"
                    :key="item"
                    :label="item-1"
                    :value="item-1"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <span>天开始</span>
            </div>
          </el-form-item>
          <el-form-item
            label="截止放号时间"
            required
          >
            <div class="flex">
              <span>问诊日期前</span>
              <el-form-item prop="end_release_num_day">
                <el-select
                  v-model="ruleForm.end_release_num_day"
                  style="width:110px;margin:0 5px"
                  placeholder=""
                >
                  <el-option
                    v-for="item in 31"
                    :key="item"
                    :label="item-1"
                    :value="item-1"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <span>天结束</span>
            </div>
          </el-form-item>
        </el-form>
        <div style="text-align: center;margin-top:40px">
          <el-button
            plain
            size="medium"
            @click="register=false"
          >取消</el-button>
          <el-button
            type="primary"
            size="medium"
            @click="submit('ruleForm')"
            :disabled="module_id_array[0] ? !module_id_array.includes('1089') : false"
          >确认</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 设置医生问诊弹窗 -->
    <el-dialog
      :title="title"
      :visible.sync="doctor_register"
      width="600px"
      :close-on-click-modal="false"
      close="cancelEdit"
    >
      <div class="registerdialogbox">
        <div style="font-weight:700;font-size:16px;margin-bottom:22px">
          {{doctor_data.hospital}}
        </div>
        <div>
          <div class="diatitle">上午坐诊设置</div>
          <div>
            <span class="dialabel">坐诊时间</span>
            <el-time-select
              :disabled="scheduling_detail[0].count>0"
              style="width:150px"
              placeholder="起始时间"
              v-model="scheduling_detail[0].start_time"
              :picker-options="{
                    start: '06:00',
                    step: '00:05',
                    end: '13:55',
                 maxTime:scheduling_detail[0].end_time
                            }"
            >
            </el-time-select>
            <span style="margin:0 5px">~</span>
            <el-time-select
              :disabled="scheduling_detail[0].count>0"
              style="width:150px"
              placeholder="结束时间"
              v-model="scheduling_detail[0].end_time"
              :picker-options="{
                    start: '06:00',
                    step: '00:05',
                    end: '13:55',
                    minTime: scheduling_detail[0].start_time
                             }"
            >
            </el-time-select>
          </div>
          <div style="margin:12px 0">
            <span class="dialabel">看诊时长</span>
            <el-select
              v-model="scheduling_detail[0].duration"
              style="width:90px;margin-right:3px"
              clearable=""
              :disabled="scheduling_detail[0].count>0"
            >
              <el-option
                v-for="item in 60"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <span>分钟</span>
          </div>
          <div>
            <span class="dialabel">坐诊类型</span>
            <el-radio-group v-model="scheduling_detail[0].type">
              <el-radio :label="2">坐诊且放号</el-radio>
              <el-radio :label="1">仅坐诊</el-radio>
              <el-radio :label="3">不坐诊</el-radio>
            </el-radio-group>
          </div>
          <div
            style="margin-top:12px"
            v-if="scheduling_detail[0].type==2"
          >
            <span class="dialabel">放号数</span>
            <el-input-number
              v-model="scheduling_detail[0].total_num"
              :min="1"
              :precision="0"
              :controls="false"
            ></el-input-number>
          </div>
        </div>
        <div>
          <div
            class="diatitle"
            style="margin-top:20px"
          >下午坐诊设置</div>
          <div>
            <span class="dialabel">坐诊时间</span>
            <el-time-select
              :disabled="scheduling_detail[1].count>0"
              style="width:150px"
              placeholder="起始时间"
              v-model="scheduling_detail[1].start_time"
              :picker-options="{
                    start: '12:00',
                    step: '00:05',
                    end: '19:55',
                 maxTime:scheduling_detail[1].end_time,
                 minTime: scheduling_detail[0].end_time
                            }"
            >
            </el-time-select>
            <span style="margin:0 5px">~</span>
            <el-time-select
              :disabled="scheduling_detail[1].count>0"
              style="width:150px"
              placeholder="结束时间"
              v-model="scheduling_detail[1].end_time"
              :picker-options="{
                    start: '12:00',
                    step: '00:05',
                    end: '19:55',
                    minTime: scheduling_detail[1].start_time
                             }"
            >
            </el-time-select>
          </div>
          <div style="margin:12px 0">
            <span class="dialabel">看诊时长</span>
            <el-select
              :disabled="scheduling_detail[1].count>0"
              v-model="scheduling_detail[1].duration"
              style="width:90px;margin-right:3px"
              clearable=""
            >
              <el-option
                v-for="item in 60"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <span>分钟</span>
          </div>
          <div>
            <span class="dialabel">坐诊类型</span>
            <el-radio-group v-model="scheduling_detail[1].type">
              <el-radio :label="2">坐诊且放号</el-radio>
              <el-radio :label="1">仅坐诊</el-radio>
              <el-radio :label="3">不坐诊</el-radio>
            </el-radio-group>
          </div>
          <div
            style="margin-top:12px"
            v-if="scheduling_detail[1].type==2"
          >
            <span class="dialabel">放号数</span>
            <el-input-number
              v-model="scheduling_detail[1].total_num"
              :min="1"
              :precision="0"
              :controls="false"
            ></el-input-number>
          </div>
        </div>
        <div>
          <div
            class="diatitle"
            style="margin-top:20px"
          >晚上坐诊设置</div>
          <div>
            <span class="dialabel">坐诊时间</span>
            <el-time-select
              :disabled="scheduling_detail[2].count>0"
              style="width:150px"
              placeholder="起始时间"
              v-model="scheduling_detail[2].start_time"
              :picker-options="{
                    start: '18:00',
                    step: '00:05',
                    end: '23:55',
                 maxTime:scheduling_detail[2].end_time,
                minTime: scheduling_detail[1].end_time
                            }"
            >
            </el-time-select>
            <span style="margin:0 5px">~</span>
            <el-time-select
              :disabled="scheduling_detail[2].count>0"
              style="width:150px"
              placeholder="结束时间"
              v-model="scheduling_detail[2].end_time"
              :picker-options="{
                    start: '18:00',
                    step: '00:05',
                    end: '23:55',
                    minTime: scheduling_detail[2].start_time
                             }"
            >
            </el-time-select>
          </div>
          <div style="margin:12px 0">
            <span class="dialabel">看诊时长</span>
            <el-select
              :disabled="scheduling_detail[2].count>0"
              v-model="scheduling_detail[2].duration"
              style="width:90px;margin-right:3px"
              clearable=""
            >
              <el-option
                v-for="item in 60"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <span>分钟</span>
          </div>
          <div>
            <span class="dialabel">坐诊类型</span>
            <el-radio-group v-model="scheduling_detail[2].type">
              <el-radio :label="2">坐诊且放号</el-radio>
              <el-radio :label="1">仅坐诊</el-radio>
              <el-radio :label="3">不坐诊</el-radio>
            </el-radio-group>
          </div>
          <div
            style="margin-top:12px"
            v-if="scheduling_detail[2].type==2"
          >
            <span class="dialabel">放号数</span>
            <el-input-number
              v-model="scheduling_detail[2].total_num"
              :min="1"
              :precision="0"
              :controls="false"
            ></el-input-number>
          </div>
        </div>
        <div style="margin-top:30px">
          <span class="dialabel">重复设置</span>
          <el-checkbox
            v-model="doctor_data.set_status"
            :true-label="1"
            :false-label="0"
          >以后每{{dialog_week}}，都这样设置</el-checkbox>
        </div>
      </div>

      <div style="text-align: center;padding:30px 0 20px">
        <el-button
          plain
          @click="cancelEdit"
        >取消</el-button>
        <el-button
          type="primary"
          @click="setScheduleDate"
          :disabled="module_id_array[0] ? !module_id_array.includes('1089') : false"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
export default {
  data() {
    let checkOpenDay = (rule, value, callback) => {
      if (value || value == 0) {
        if (
          (this.ruleForm.start_release_num_day ||
            this.ruleForm.start_release_num_day == 0) &&
          this.ruleForm.end_release_num_day |
            (this.ruleForm.end_release_num_day == 0)
        ) {
          if (
            this.ruleForm.start_release_num_day <
            this.ruleForm.end_release_num_day
          ) {
            return callback(new Error('放号截止时间必须大于开始时间'));
          } else {
            return callback();
          }
        } else {
          return callback();
        }
      } else {
        return callback();
      }
    };
    return {
      value: false,
      doctor_id: this.$route.query.doctor_id,
      currentDay: 1,
      currentMonth: 1,
      currentYear: 1970,
      currentWeek: 1,
      weeks: [
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六',
        '星期日'
      ],
      days: [],
      detail: {},
      schListShow: false,
      doctor_name: '',
      phone: '',
      hospital: '',
      doctorSchList: [],
      today: dayjs(new Date()).format('YYYY-MM-DD'),
      month: '',
      hospital_list: [],
      register: false,
      regions: [], //地区
      search_list: [], //搜索药房列表
      ruleForm: {
        doctor_id: this.$route.query.doctor_id,
        hospital: '', //所在医院
        regions: [], //省市区
        address: '',
        morning_start_time: '',
        morning_end_time: '',
        morning_duration: '',
        afternoon_start_time: '',
        afternoon_end_time: '',
        afternoon_duration: '',
        night_start_time: '',
        night_end_time: '',
        night_duration: '',
        change_time: 0,
        start_release_num_day: '',
        end_release_num_day: ''
      },
      rules: {
        hospital: [
          {
            required: true,
            message: '请选择坐诊医院',
            trigger: ['blur', 'change']
          }
        ],
        change_time: [
          { required: true, message: '请选择是否可选时间', trigger: 'blur' }
        ],
        start_release_num_day: [
          { required: true, message: '请填写开始放号时间', trigger: 'blur' },
          { validator: checkOpenDay, trigger: ['blur', 'change'] }
        ],
        end_release_num_day: [
          { required: true, message: '请填写结束放号时间', trigger: 'blur' },
          { validator: checkOpenDay, trigger: ['blur', 'change'] }
        ]
      },
      area_id: '',
      doctor_register: false,
      addData: {},
      title: '11月2日周二上午',
      dialog_week: '周二',
      scheduling_time: '',
      hospital_name: '',
      doctor_data: {},
      scheduling_detail: [
        {
          scheduling_time: '',
          scheduling_type: 1,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        },
        {
          scheduling_time: '',
          scheduling_type: 2,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        },
        {
          scheduling_time: '',
          scheduling_type: 4,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        }
      ],
      left_data: {},
      left_list: [],
      addInfo: {}
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    newArr: function () {
      return JSON.parse(JSON.stringify(this.scheduling_detail));
    }
  },
  watch: {
    newArr: {
      deep: true,
      handler(newValue, oldValue) {
        for (let i = 0; i < newValue.length; i++) {
          let day = '上午';
          if (newValue[i].scheduling_type == 2) {
            day = '下午';
          }
          if (newValue[i].scheduling_type == 4) {
            day = '晚上';
          }
          if (newValue[i].count > 0) {
            if (oldValue[i].type == 2 && newValue[i].type == 1) {
              this.$alert(
                `【${day}】已挂号${oldValue[i].count}位患者不受影响，提交后不可再预约，提交后已预约挂号的挂号数据不受影响`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {}
                }
              );
            }
            if (oldValue[i].type == 2 && newValue[i].type == 3) {
              this.$alert(
                `【${day}】已挂号${oldValue[i].count}位患者系统将为患者办理退号哦，请知晓。提交后已预约挂号的系统将取消状态更新为已退号，并给患者发送取消退号短信`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {}
                }
              );
            }
            if (oldValue[i].type == 1 && newValue[i].type == 3) {
              this.$alert(
                `【${day}】已挂号${oldValue[i].count}位患者系统将为患者办理退号哦，请知晓。提交后已预约挂号的系统将取消状态更新为已退号，并给患者发送取消退号短信`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {}
                }
              );
            }
            if (oldValue[i].total_num > newValue[i].total_num) {
              this.$alert(
                `【${day}】已挂号${oldValue[i].count}位患者不受影响，请知晓`,
                '提示',
                {
                  confirmButtonText: '确定',
                  callback: (action) => {}
                }
              );
            }
          }
        }
      }
    }
  },
  methods: {
    //获取医生详情
    getDoctor() {
      let doctor_id = this.doctor_id;
      this.axios
        .post('platform/doctor/doctorItem', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.detail = res.data.info;
            let good_at = [];
            good_at = this.detail.be_good_at.map((item) => {
              return item.be_good_at_name;
            });
            this.detail.good_at = good_at.toString();
            this.value = this.detail.is_scheduling ? true : false;
          }
        });
    },
    // 获取医生坐诊地点列表
    getSchedulingArea() {
      let doctor_id = this.doctor_id;
      this.axios
        .post('platform/doctor/doctorSchedulingArea', { doctor_id })
        .then((res) => {
          if (res.code == 0) {
            this.hospital_list = res.data ? res.data : [];
            if (this.hospital_list.length) {
              this.area_id = this.hospital_list[0].area_id;
            }
            this.getList();
            this.getSchedulingDetail();
          }
        });
    },
    //改变日期左边数据变化
    changeBg(scheduling_time) {
      this.scheduling_time = scheduling_time;
      this.getSchedulingDetail(scheduling_time);
    },
    //取消坐诊修改
    cancelEdit() {
      this.scheduling_detail = [
        {
          scheduling_time: '',
          scheduling_type: 1,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        },
        {
          scheduling_time: '',
          scheduling_type: 2,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        },
        {
          scheduling_time: '',
          scheduling_type: 4,
          type: '',
          total_num: undefined,
          start_time: '',
          end_time: '',
          duration: '',
          count: 0
        }
      ];
      this.getSchedulingDetail(this.doctor_data.scheduling_time);
    },

    //获取医生指定日期坐诊详情
    getSchedulingDetail(scheduling_time) {
      this.doctor_register = false;
      if (!this.area_id) {
        return false;
      }
      let data = {
        scheduling_time: scheduling_time
          ? scheduling_time
          : dayjs(new Date()).format('YYYY-MM-DD'),
        doctor_id: this.doctor_id,
        area_id: this.area_id
      };
      this.axios
        .post('platform/doctor/doctorSchedulingDetail', data)
        .then((res) => {
          if (res.code == 0) {
            this.left_data = {
              area_id: res.data.area_id,
              doctor_id: res.data.doctor_id,
              hospital: res.data.hospital,
              scheduling_time: dayjs
                .unix(res.data.scheduling_time)
                .format('YYYY-MM-DD'),
              set_status: res.data.set_status
            };
            this.left_data.dialog_week =
              '星期' +
              '日一二三四五六'.charAt(
                new Date(this.left_data.scheduling_time).getDay()
              );
            if (!res.data.info.length) {
              this.left_list = [];
            }
            let mn = [1, 2, 4];
            let add_arr = [];

            if (res.data.info.length == 1 || res.data.info.length == 2) {
              let info_arr = res.data.info.map((item) => {
                item.start_time = item.start_time
                  ? dayjs.unix(item.start_time).format('HH:mm')
                  : '';
                item.end_time = item.end_time
                  ? dayjs.unix(item.end_time).format('HH:mm')
                  : '';
                return item;
              });
              for (let j = 0; j < info_arr.length; j++) {
                for (let i = 0; i < mn.length; i++) {
                  if (info_arr[j].scheduling_type == mn[i]) {
                    let index = mn.indexOf(info_arr[j].scheduling_type);
                    mn.splice(index, 1);
                  }
                }
              }
              add_arr = mn.map((item) => {
                let data = {
                  scheduling_type: item,
                  scheduling_time: '',
                  type: '',
                  total_num: undefined,
                  start_time: '',
                  end_time: '',
                  duration: '',
                  count: 0
                };
                return data;
              });
              this.left_list = add_arr.concat(info_arr).sort((a, b) => {
                return a.scheduling_type - b.scheduling_type;
              });
            }
            if (res.data.info.length == 3) {
              this.left_list = res.data.info.map((item) => {
                item.start_time = item.start_time
                  ? dayjs.unix(item.start_time).format('HH:mm')
                  : '';
                item.end_time = item.end_time
                  ? dayjs.unix(item.end_time).format('HH:mm')
                  : '';
                return item;
              });
            }
          }
        });
    },
    //获取省市区列表
    getRegion() {
      let url = 'platform/platform/getProvinceCityDistrict';
      this.axios.post(url).then((res) => {
        let regions = res.data.list;
        this.transRegions(regions);
        this.regions = regions;
      });
    },
    transRegions(tree) {
      tree.forEach((item) => {
        if (item.city || item.district) {
          item.children = item.city || item.district;
          delete item.city;
          delete item.district;
          this.transRegions(item.children);
        }
        if (item.province_id) {
          item.value = item.province_id;
          delete item.province_id;
        }
        if (item.city_id) {
          item.value = item.city_id;
          delete item.city_id;
        }
        if (item.district_id) {
          item.value = item.district_id;
          delete item.district_id;
        }

        if (item.name) {
          item.label = item.name;
          delete item.name;
        }
      });
    },
    getLastDay(d) {
      var current = new Date(d);
      var currentMonth = current.getMonth();
      var nextMonth = ++currentMonth;
      var nextMonthDayOne = new Date(current.getFullYear(), nextMonth, 1);
      var minusDate = 1000 * 60 * 60 * 24;
      let lastDay = new Date(nextMonthDayOne.getTime() - minusDate);
      return dayjs(lastDay).format('YYYY-MM-DD');
    },
    //远程搜索药房
    getHospital(keywords) {
      if (keywords) {
        let hospital = keywords;
        this.axios
          .post('platform/doctor/platformhospitallist', { hospital })
          .then((res) => {
            this.search_list = res.data;
          });
      } else {
        this.axios.post('platform/doctor/platformhospitallist').then((res) => {
          this.search_list = res.data;
        });
      }
    },
    //获取医生坐班表信息
    getList() {
      if (!this.area_id) {
        return false;
      }
      let data = {
        doctor_id: this.$route.query.doctor_id,
        area_id: this.area_id,
        month: this.month
      };
      this.axios
        .post('platform/doctor/doctorSchedulingList', data)
        .then((res) => {
          if (res.code == 0) {
            let list = res.data.map((item) => {
              item.scheduling_time = dayjs
                .unix(item.scheduling_time)
                .format('YYYY-MM-DD');
              return item;
            });
            for (let i = 0; i < this.days.length; i++) {
              for (let j = 0; j < list.length; j++) {
                if (this.days[i].scheduling_time == list[j].scheduling_time) {
                  this.days[i].other_afternoon = list[j].other_afternoon;
                  this.days[i].other_morning = list[j].other_morning;
                  this.days[i].other_night = list[j].other_night;
                  this.days[i].scheduling_str = list[j].scheduling_str;
                  this.days[i].area_id = list[j].area_id;
                  this.days[i].count = list[j].count;
                  this.days[i].doctor_id = list[j].doctor_id;
                  this.days[i].info = list[j].info;
                  this.days[i].scheduling_id = list[j].scheduling_id;
                  this.days[i].total_num = list[j].total_num
                    ? Number(list[j].total_num)
                    : 0;
                }
              }
            }
            this.$forceUpdate();
          }
        });
    },
    back() {
      history.back();
    },
    //切换月份
    changeMonth(value) {
      let date = new Date(value);
      this.init(this.formDate(date.getFullYear(), date.getMonth() + 1, 1));
    },

    //返回字符串个格式的日期
    formDate(year, month, day) {
      return year + '-' + month + '-' + day;
    },
    //日历初始化
    init(data) {
      let day;
      if (data) {
        day = new Date(data);
      } else {
        let now = new Date();
        day = new Date(this.formDate(now.getFullYear(), now.getMonth() + 1, 1));
      }
      this.currentDay = day.getDate();
      this.currentYear = day.getFullYear();
      this.currentMonth = day.getMonth() + 1;
      this.currentWeek = day.getDay();
      if (!this.currentWeek) {
        this.currentWeek = 7;
      }
      this.days.length = 0;
      let str = this.formDate(
        this.currentYear,
        this.currentMonth,
        this.currentDay
      );
      let rest_day = [];
      //获取上月末至本月第一天的日期
      for (let i = this.currentWeek - 1; i >= 0; i--) {
        let d = new Date(str);
        d.setDate(d.getDate() - i);
        rest_day.push({
          day: d
        });
      }
      let all_day = 37;
      if (rest_day.length >= 6) {
        all_day = 44;
      }
      for (let i = 2 - this.currentWeek; i < all_day - this.currentWeek; i++) {
        let d = new Date(str);
        d.setDate(i);
        this.days.push({
          day: d,
          scheduling_type: 0,
          scheduling_time: dayjs(d).format('YYYY-MM-DD')
        });
      }
      this.getList();
    },
    //其他月加class名'other'，今天加class名'active'
    chooseClass(day) {
      if (day.getMonth() + 1 != this.currentMonth) return 'other';
      let a = new Date() - day;
      if (a > 0 && a < 86400000) return 'active';
    },
    //新增医院坐诊
    addHospital() {
      this.ruleForm = {
        doctor_id: this.$route.query.doctor_id,
        hospital: '', //所在医院
        regions: [], //省市区
        address: '',
        morning_start_time: '',
        morning_end_time: '',
        morning_duration: '',
        afternoon_start_time: '',
        afternoon_end_time: '',
        afternoon_duration: '',
        night_start_time: '',
        night_end_time: '',
        night_duration: '',
        change_time: 0,
        start_release_num_day: '',
        end_release_num_day: ''
      };
      this.register = true;
    },
    //编辑医院坐诊
    editHospital(area_id) {
      let push_data = {
        doctor_id: this.doctor_id,
        area_id: area_id
      };
      this.axios
        .post('platform/doctor/doctorSchedulingAreaInfo', push_data)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.info;
            this.ruleForm = {
              doctor_id: this.$route.query.doctor_id,
              area_id: data.area_id,
              hospital: data.hospital, //所在医院
              regions: [data.province_id, data.city_id, data.district_id], //省市区
              address: data.address,
              morning_start_time: data.morning_start_time
                ? dayjs.unix(data.morning_start_time).format('HH:mm')
                : '',
              morning_end_time: data.morning_end_time
                ? dayjs.unix(data.morning_end_time).format('HH:mm')
                : '',
              morning_duration: data.morning_duration
                ? data.morning_duration
                : undefined,
              afternoon_start_time: data.afternoon_start_time
                ? dayjs.unix(data.afternoon_start_time).format('HH:mm')
                : '',
              afternoon_end_time: data.afternoon_end_time
                ? dayjs.unix(data.afternoon_end_time).format('HH:mm')
                : '',
              afternoon_duration: data.afternoon_duration
                ? data.afternoon_duration
                : undefined,
              night_start_time: data.night_start_time
                ? dayjs.unix(data.night_start_time).format('HH:mm')
                : '',
              night_end_time: data.night_end_time
                ? dayjs.unix(data.night_end_time).format('HH:mm')
                : '',
              night_duration: data.night_duration
                ? data.night_duration
                : undefined,
              change_time: data.change_time,
              start_release_num_day: data.start_release_num_day,
              end_release_num_day: data.end_release_num_day
            };
            this.register = true;
          }
        });
    },
    //新增编辑坐诊地
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (
            (this.ruleForm.morning_start_time &&
              !this.ruleForm.morning_end_time &&
              !this.ruleForm.morning_duration) ||
            (!this.ruleForm.morning_start_time &&
              this.ruleForm.morning_end_time &&
              !this.ruleForm.morning_duration) ||
            (!this.ruleForm.morning_start_time &&
              !this.ruleForm.morning_end_time &&
              this.ruleForm.morning_duration) ||
            (!this.ruleForm.morning_start_time &&
              this.ruleForm.morning_end_time &&
              this.ruleForm.morning_duration) ||
            (this.ruleForm.morning_start_time &&
              !this.ruleForm.morning_end_time &&
              this.ruleForm.morning_duration) ||
            (this.ruleForm.morning_start_time &&
              this.ruleForm.morning_end_time &&
              !this.ruleForm.morning_duration)
          ) {
            this.$message.error('完善上午坐诊时间');
            return false;
          }
          if (
            (this.ruleForm.afternoon_start_time &&
              !this.ruleForm.afternoon_end_time &&
              !this.ruleForm.afternoon_duration) ||
            (!this.ruleForm.afternoon_start_time &&
              this.ruleForm.afternoon_end_time &&
              !this.ruleForm.afternoon_duration) ||
            (!this.ruleForm.afternoon_start_time &&
              !this.ruleForm.afternoon_end_time &&
              this.ruleForm.afternoon_duration) ||
            (!this.ruleForm.afternoon_start_time &&
              this.ruleForm.afternoon_end_time &&
              this.ruleForm.afternoon_duration) ||
            (this.ruleForm.afternoon_start_time &&
              !this.ruleForm.afternoon_end_time &&
              this.ruleForm.afternoon_duration) ||
            (this.ruleForm.afternoon_start_time &&
              this.ruleForm.afternoon_end_time &&
              !this.ruleForm.afternoon_duration)
          ) {
            this.$message.error('完善下午坐诊时间');
            return false;
          }
          if (
            (this.ruleForm.night_start_time &&
              !this.ruleForm.night_end_time &&
              !this.ruleForm.night_duration) ||
            (!this.ruleForm.night_start_time &&
              this.ruleForm.night_end_time &&
              !this.ruleForm.night_duration) ||
            (!this.ruleForm.night_start_time &&
              !this.ruleForm.night_end_time &&
              this.ruleForm.night_duration) ||
            (this.ruleForm.night_start_time &&
              this.ruleForm.night_end_time &&
              !this.ruleForm.night_duration) ||
            (this.ruleForm.night_start_time &&
              this.ruleForm.night_end_time &&
              !this.ruleForm.night_duration) ||
            (this.ruleForm.night_start_time &&
              !this.ruleForm.night_end_time &&
              this.ruleForm.night_duration)
          ) {
            this.$message.error('完善晚上坐诊时间');
            return false;
          }
          let data = this.ruleForm;
          if (this.ruleForm.regions.length) {
            data.province_id = this.ruleForm.regions[0];
            data.city_id = this.ruleForm.regions[1];
            data.district_id = this.ruleForm.regions[2];
          }
          let today = dayjs(new Date()).format('YYYY-MM-DD');
          if (data.morning_start_time) {
            data.morning_start_time = today + data.morning_start_time;
            data.morning_end_time = today + data.morning_end_time;
          }
          if (data.afternoon_start_time) {
            data.afternoon_start_time = today + data.afternoon_start_time;
            data.afternoon_end_time = today + data.afternoon_end_time;
          }
          if (data.night_start_time) {
            data.night_start_time = today + data.night_start_time;
            data.night_end_time = today + data.night_end_time;
          }
          this.axios
            .post('platform/doctor/saveDoctorSchedulingArea', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('保存成功');
                this.register = false;
                this.getSchedulingArea();
              }
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    //删除坐诊地
    delHospital(item) {
      let msg =
        '确定删除当前医疗机构吗？删除后，该机构设置的坐诊信息将一并删除。';
      if (item.register_count > 0) {
        msg =
          '当前已有患者预约线下加号，确定删除当前医疗机构吗？删除后，已预约的患者将被取消预约。';
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          let data = {
            doctor_id: this.doctor_id,
            area_id: item.area_id
          };
          this.axios
            .post('platform/doctor/delDoctorSchedulingArea', data)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success('删除成功');
                this.getSchedulingArea();
              }
            });
        })
        .catch(() => {});
    },
    //设置医生弹窗
    saveDoctorRegisterDia(scheduling_time, val) {
      if (val.info) {
        return false;
      }
      if (val.other_afternoon && val.other_morning && val.other_night) {
        return false;
      }
      this.addInfo = val;
      let totalDays, diffDate;
      let chooseTime = Date.parse(scheduling_time);
      let today = Date.parse(this.today);
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(chooseTime - today); // 取相差毫秒数的绝对值
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
      if (totalDays > 180) {
        this.$message.error('只可预先设置之后180天的数据');
        return false;
      }
      this.dialog_week =
        '星期' + '日一二三四五六'.charAt(new Date(scheduling_time).getDay());
      this.title = scheduling_time + '  ' + this.dialog_week;

      let push_data = {
        doctor_id: this.doctor_id,
        area_id: this.area_id
      };
      this.axios
        .post('platform/doctor/doctorSchedulingAreaInfo', push_data)
        .then((res) => {
          if (res.code == 0) {
            let data = res.data.info;
            this.doctor_data = {
              hospital: data.hospital,
              doctor_id: this.doctor_id,
              area_id: this.area_id,
              set_status: 0
            };
            this.scheduling_detail = [
              {
                scheduling_time: scheduling_time,
                scheduling_type: 1,
                type: 3,
                total_num: undefined,
                start_time: data.morning_start_time
                  ? dayjs.unix(data.morning_start_time).format('HH:mm')
                  : '',
                end_time: data.morning_end_time
                  ? dayjs.unix(data.morning_end_time).format('HH:mm')
                  : '',
                duration: data.morning_duration
                  ? data.morning_duration
                  : undefined,
                count: 0
              },
              {
                scheduling_time: scheduling_time,
                scheduling_type: 2,
                type: 3,
                total_num: undefined,
                start_time: data.afternoon_start_time
                  ? dayjs.unix(data.afternoon_start_time).format('HH:mm')
                  : '',
                end_time: data.afternoon_end_time
                  ? dayjs.unix(data.afternoon_end_time).format('HH:mm')
                  : '',
                duration: data.afternoon_duration
                  ? data.afternoon_duration
                  : undefined,
                count: 0
              },
              {
                scheduling_time: scheduling_time,
                scheduling_type: 4,
                type: 3,
                total_num: undefined,
                start_time: data.night_start_time
                  ? dayjs.unix(data.night_start_time).format('HH:mm')
                  : '',
                end_time: data.night_end_time
                  ? dayjs.unix(data.night_end_time).format('HH:mm')
                  : '',
                duration: data.night_duration ? data.night_duration : undefined,
                count: 0
              }
            ];
            this.doctor_register = true;
          }
        });
    },
    //编辑医生指定日期坐诊弹窗
    editDoctorRegisterDia() {
      if (!this.left_data.scheduling_time) {
        return false;
      }
      if (
        this.left_data.scheduling_time < dayjs(new Date()).format('YYYY-MM-DD')
      ) {
        return false;
      }
      if (!this.left_list.length) {
        this.saveDoctorRegisterDia(
          this.left_data.scheduling_time,
          this.addInfo
        );
        return false;
      }

      let totalDays, diffDate;
      let chooseTime = Date.parse(this.left_data.scheduling_time);
      let today = Date.parse(this.today);
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(chooseTime - today); // 取相差毫秒数的绝对值
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
      if (totalDays > 180) {
        this.$message.error('只可预先设置之后180天的数据');
        return false;
      }
      this.title =
        this.left_data.scheduling_time + '  ' + this.left_data.dialog_week;
      this.scheduling_detail = this.left_list.map((item) => {
        item.scheduling_time = this.left_data.scheduling_time;
        item.type = item.type ? item.type : 3;
        return item;
      });
      this.doctor_data = this.left_data;
      this.dialog_week = this.left_data.dialog_week;

      this.doctor_register = true;
    },
    //添加/编辑
    setScheduleDate() {
      let data = this.doctor_data;
      let scheduling_detail = this.scheduling_detail;
      for (let i = 0; i < scheduling_detail.length; i++) {
        if (
          (scheduling_detail[i].start_time &&
            !scheduling_detail[i].end_time &&
            !scheduling_detail[i].duration) ||
          (!scheduling_detail[i].start_time &&
            scheduling_detail[i].end_time &&
            !scheduling_detail[i].duration) ||
          (!scheduling_detail[i].start_time &&
            !scheduling_detail[i].end_time &&
            scheduling_detail[i].duration) ||
          (scheduling_detail[i].start_time &&
            scheduling_detail[i].end_time &&
            !scheduling_detail[i].duration) ||
          (!scheduling_detail[i].start_time &&
            scheduling_detail[i].end_time &&
            scheduling_detail[i].duration) ||
          (scheduling_detail[i].start_time &&
            !scheduling_detail[i].end_time &&
            scheduling_detail[i].duration)
        ) {
          this.$message.error('完善坐诊时间');
          return false;
        }
        // if (!scheduling_detail[i].type) {
        //   this.$message.error('请选择坐诊类型');
        //   return false;
        // }
        if (scheduling_detail[i].type == 2 && !scheduling_detail[i].total_num) {
          this.$message.error('请输入就诊放号数');
          return false;
        }
      }
      data.scheduling_detail = this.scheduling_detail.map((item) => {
        item.start_time = item.start_time
          ? item.scheduling_time + ' ' + item.start_time
          : '';
        item.end_time = item.end_time
          ? item.scheduling_time + ' ' + item.end_time
          : '';
        return item;
      });

      this.axios
        .post('platform/doctor/dateDoctorScheduling', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('设置成功');
            this.doctor_register = false;
            this.getList();
            this.getSchedulingDetail(
              res.data ? dayjs.unix(res.data).format('YYYY-MM-DD') : ''
            );
          }
        })
        .catch((error) => {
          console.log(error);
          this.scheduling_detail.forEach((item) => {
            item.start_time = item.start_time
              ? dayjs(item.start_time).format('HH:mm')
              : '';
            item.end_time = item.end_time
              ? dayjs(item.end_time).format('HH:mm')
              : '';
          });
        });
    },
    changeHospital(area_id) {
      this.area_id = area_id;
      this.getList(area_id);
      this.getSchedulingDetail();
    }
  },
  created() {
    this.init();
    this.getRegion();
    this.getHospital();
    this.getSchedulingArea();
    this.getDoctor();
    this.month = dayjs(new Date()).format('YYYY-MM');
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.info {
  background: #f5f5f5;
  padding: 10px;
  margin-bottom: 20px;
  .item {
    margin-right: 50px;
  }
}
.black {
  font-weight: 700;
  margin-right: 20px;
}
ul {
  list-style-type: none;
}

#calendar {
  flex: 1;
  border-radius: 2px;
  box-sizing: border-box;
}

.title {
  font-size: 24px;
  background-color: hsla(144, 51%, 10%, 0.4);
  color: #ffffff;
  height: 50px;
  line-height: 50px;
  margin-top: 16px;
  text-align: center;
}
.weekdays {
  padding: 0;
  background: #ffffff;
  margin: 0;
  display: flex;
  border-right: 1px solid #333;
  border-top: 1px solid #333;
}

.weekname {
  display: inline-block;
  flex: 1;
  text-align: center;
  line-height: 50px;
  box-sizing: border-box;
  border-left: 1px solid #333;
  font-weight: 600;
}
.days {
  padding: 0;
  background: #ffffff;
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  border-right: 1px solid #333;
  border-top: 1px solid #333;
}
.days li {
  display: inline-block;
  width: 14.285714%;
  text-align: center;
  padding-bottom: 8px;
  padding-top: 15px;
  height: 89px;
  box-sizing: border-box;
  border-left: 1px solid #333;
  border-bottom: 1px solid #333;
}

.days li .active {
  padding: 4px 10px;
  border-radius: 50%;
  background: hsla(144, 51%, 10%, 0.3);
  color: #fff;
}

.days li .other {
  padding: 5px;
  color: gainsboro;
}

.days li:hover {
  background: #e1e1e1;
}
.dialog_content {
  padding: 15px;
  text-align: left;
  line-height: 40px;
  .top {
    background-color: #ddd4d49a;
    padding: 0 10px;
  }
  .box {
    max-height: 430px;
    overflow: auto;
    .item:nth-child(2n) {
      background: #f5f5f5;
    }
  }
  .el-checkbox {
    margin-right: 15px;
  }
}
.left_box {
  background: #f5f5f5;
  width: 300px;
  margin-right: 20px;
  padding: 20px;
  box-sizing: border-box;
}
.hospital_box {
  width: calc(100vw - 620px);
  height: 170px;
  overflow-x: scroll;
  margin-bottom: 16px;
  position: relative;
  .scroll_box {
    min-width: calc(100vw - 620px);
    // width: 10000px;
    position: absolute;
    overflow: hidden;
  }
  .hospital {
    background: #f5f5f5;
    width: 280px;
    height: 140px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    border-radius: 10px;
    margin-right: 15px;
    padding: 10px;
    position: relative;
    box-sizing: border-box;
    .btnbox {
      position: absolute;
      bottom: -8px;
      right: 3px;
    }
    .name {
      font-weight: 700;
      margin-bottom: 6px;
    }
    .address {
      font-size: 12px;
      color: #666;
    }
  }
}
.registerdialogbox {
  padding: 20px 15px 20px 30px;
  text-align: left;
}
.diatitle {
  font-weight: 700;
  margin-bottom: 16px;
}
.dialabel {
  display: inline-block;
  width: 80px;
  text-align: right;
  margin-right: 10px;
}
.other_place {
  font-size: 10px;
  // color: #ea5c5c;
}
</style>
<style>
.registerdialogbox .el-form-item {
  margin-bottom: 15px;
}
.registerdialogbox .el-form-item__error {
  padding-top: 0px;
  width: 170px;
}
</style>